import React, { Component } from "react"
import moment from "moment"
import { Modal, Button, FormControl} from "react-bootstrap"
import EmployeeDataTypes from "../../../../../Types/EmployeeTypes"
import contactBoilerplate from "./ContactBoilerplate"
import reggie from "../../../../../../../utilities/Reggie"
import "./EmergencyContacts.css"

interface EmergencyContactProps {
    employee: EmployeeDataTypes
    userId: any
    toggleEdit: Function
    appendParams: Function
}

type EmergencyContactTypes = {
    eventType: Object
    contacts: Array<any>
    employee: EmployeeDataTypes | {}
}

class EmergencyContacts extends Component<EmergencyContactProps, EmergencyContactTypes> {

    copy: any = []
    index = -1

    state = {
        eventType: { event: "", index: 0 },
        contacts: [],
        employee: {},
    }

    componentDidMount() {
        this.formatContacts()
        this.setState({ employee: this.props.employee })
    }

    formatContacts = () => {
        this.index = -1
        if (this.props.employee) {
            let contacts = this.props.employee.EmergencyContacts
            let temp = []
            for (let i = 0; i < 3; i++) {
                if (!contacts[i]) {
                    temp.push(JSON.parse(JSON.stringify(contactBoilerplate)))
                } else {
                    temp.push(contacts[i])
                }
            }
            this.setState({ contacts: temp })
            this.copy = JSON.parse(JSON.stringify(temp))
        } else {
            this.setState({ contacts: [JSON.parse(JSON.stringify(contactBoilerplate)), JSON.parse(JSON.stringify(contactBoilerplate)), JSON.parse(JSON.stringify(contactBoilerplate))] })
            this.copy = [JSON.parse(JSON.stringify(contactBoilerplate)), JSON.parse(JSON.stringify(contactBoilerplate)), JSON.parse(JSON.stringify(contactBoilerplate))]
        }
    }

    handleInputFocus = (type: string, index: number) => {
        this.setState({ eventType: { event: type, index: index } })
    }

    handleChange = (event: { target: { value: string } }) => {
        let input = event.target.value
        let temp: any = this.state.contacts
        temp[this.state.eventType.index][this.state.eventType.event] = input
        this.props.appendParams([{ EmergencyContacts: temp }])
    }

    handleDelete = (index: number) => {
        let temp: any = this.state.contacts
        temp[index].DeletedDate = moment().format()
        temp[index].DeletedBy = parseInt(this.props.userId)
        temp[index].EmergencyContactName = null
        temp[index].EmergencyContactPhone = null
        this.setState({ contacts: temp })
        this.props.appendParams([{ EmergencyContacts: temp }])
    }

    render() {

        // //console.log(this.props)
        // //console.log(this.state.contacts)
        // //console.log(this.state)

        return (
            <div className="EmergencyContacts">
                <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="EditEmergencyContactsHeader">
                            <p>Emergency Contacts</p>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.contacts.length > 0 && <div>
                            <div className="EmergencyContactNameNumHeader">
                                <div className="EmergencyContactNameHeader">
                                    <p>Name</p>
                                </div>
                                <div className="EmergencyContactNumHeader">
                                    <p>Number</p>
                                </div>
                            </div>
                            {this.state.contacts.map((contact: any, index: number) =>
                                <div className="EmergencyContactEditWrapper" key={`emergency-contact-${index}`}>
                                    <div className="EmergencyContactIndex" id={`emercency-contact-number-${index}`}>
                                        <p>{`${index + 1}.`}</p>
                                    </div>
                                    <div className="EmergencyContactNameForm" id={`emergency-contact-name-${contact.EmployeeEmergencyContactId}`}>
                                        <FormControl onFocus={() => this.handleInputFocus("EmergencyContactName", index)}
                                            placeholder={contact.EmergencyContactName || "*NA*"}
                                            aria-describedby="basic-addon1"
                                            onChange={this.handleChange}
                                            value={contact.EmergencyContactName || ""}
                                        />
                                    </div>
                                    <div className="EmergencyContactNumForm" id={`emergency-contact-number${contact.EmployeeEmergencyContactId}`}>
                                        <FormControl onFocus={() => this.handleInputFocus("EmergencyContactPhone", index)}
                                            placeholder={contact.EmergencyContactPhone || "*NA*"}
                                            aria-describedby="basic-addon1"
                                            onChange={this.handleChange}
                                            value={reggie.formatPhone(contact.EmergencyContactPhone) || contact.EmergencyContactPhone || ""}
                                        />
                                    </div>
                                    <div className="EmergencyContactDelete">
                                        {contact.EmployeeEmergencyContactId && !contact.DeletedDate && <span className="material-icons" onClick={() => this.handleDelete(index)}>delete</span>}
                                        {!contact.EmployeeEmergencyContactId && <span className="material-icons"></span>}
                                    </div>
                                </div>
                            )}
                        </div>}
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="EmergencyContactEditFooter">
                            <Button variant="primary" onClick={() => this.props.toggleEdit()}>Ok</Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default EmergencyContacts